/* eslint-disable @typescript-eslint/no-explicit-any */
import { isFunction, noop } from 'lodash';

// Generic type for the callback: takes Args and returns R
type Callback<Args extends any[] = any[], R = void> = (...args: Args) => R;

// Store the callback
const confirmationData: { callback: Callback } = { callback: noop };

export const useUserConfirmation = <Args extends any[] = any[], R = void>() => {
    const setConfirmationCallback = (callback: unknown) => {
        confirmationData.callback = isFunction(callback) ? (callback as Callback<Args, R>) : noop;
    };

    const getConfirmationCallback = (): Callback<Args, R> => {
        return confirmationData.callback as Callback<Args, R>;
    };

    return { getConfirmationCallback, setConfirmationCallback };
};
